<template>
    <div v-if="VERSIONS && VERSIONS[selected] && prices" class="prices-dialog">
        <div class="cu-modal bottom-modal"
             :class="(hasDisplayDesc)?'show':''">
            <div class="cu-dialog view">
                <div class="close" @click="hide"></div>
                <div class="flex-col section_6">
                    <div class="flex-col group_4">
                        <div class="self-start group_5">
                            <div class="text-cut">
                                <span class="font_4">为账号“</span>
                                <span class="font_3">{{userinfo.userName}}</span>
                                <span class="font_4">”</span>
                            </div>
                            <div>
                                <span class="font_4">购买“</span>
                                <span class="font_3">{{VERSIONS[selected].versionName}}</span>
                                <span class="font_4">”</span>
                            </div>
                        </div>
                    </div>
                    <div style="overflow-y: auto;height: 340px;box-sizing: border-box; overflow-x: hidden;padding-bottom: 240px;">
                        <div class="grid">
                            <template v-for="(item) in prices">
                                <div class="flex-col grid-item_2 space-y-10" style="position: relative"
                                     :class="item.serviceKey==serviceKey?'serviceKey-selected':''"
                                     @click="chooseServiceKey(item.serviceKey,item)">
                                    <span class="self-start font_2">{{item.description}}</span>
                                    <div class="flex-row items-baseline space-x-4">
                                        <span class="font_6">¥</span>
                                        <span class="font_5">{{item.amount/100}}</span>
                                        <span class="font_5_x" v-if="item.originAmount/1>item.amount/1">{{item.originAmount/100}}</span>
                                    </div>
                                    <div class="yiyouhui" v-if="item.originAmount/1>item.amount/1">已优惠{{(item.originAmount/1-item.amount/1)/100}}元</div>
                                </div>
                            </template>
                        </div>

                    </div>
                    <div class="flex align-center justify-between margin-top-lg">
                        <div>购买数量</div>
                        <el-input-number v-model="count" @change="handleCountChange"
                                         :min="1" :max="999" label="购买数量"></el-input-number>
                    </div>

                </div>
                <div class="flex flex-direction align-center justify-end bg-white pay-info-view margin-top">
                    <div v-if="selected > userinfo.vipType && userinfo.vipType>0"
                         class="text-left text-df text-500 padding-lr-sm margin-bottom-sm">你当前使用的{{VERSIONS[userinfo.vipType].versionName}}套餐将于<span class="text-yellow">{{unixtoTime(userinfo.endTime,'YYYY-MM-DD')}}</span>到期，若需升级{{VERSIONS[selected].versionName}}，支付相应差价完成升级</div>
                    <div @click="services" class="gotoService flex align-center justify-between">
                        <div class="flex align-center justify-start">
                            <div class="gotoServiceIcon"></div>
                            <div>找朋友帮忙付</div>
                        </div>
                        <div class="cuIcon-right text-gray"></div>
                    </div>
                    <div
                            class="flex-row justify-between items-center section_14" >
                        <div class="flex-row" v-if="amount>0">
                            <div class="flex align-center justify-start text-white tap" @click="priceDetailShow">
                                <span class="self-center font_8">¥</span>
                                <span class="text_22">{{amount/100}}</span>
                                <div class="buy-box-sub margin-left-sm">
                                    查看优惠 <span class="cuIcon-right"></span>
                                </div>
                            </div>
                        </div>
                        <div class="flex-row" v-else="">
                            <span class="self-center font_8">¥</span>
                            <span class="text_22">--</span>
                        </div>
                        <div @click="requestPayment"
                             class="flex-col justify-start items-center button_2"><span class="font_4 text_23">购买</span></div>
                    </div>
                    <div class="text-sm margin-top-sm">开通版本即表示同意
                        <router-link to="/document/privacy-agreement.pdf"><span class="text-blue">《升级协议及隐私政策》</span></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="hasManager && hasDisplayDesc" class="openMember-view flex align-center justify-center">
            <el-select v-model="paymentMethod" placeholder="请选择支付方式" style="width: 140px;">
                <el-option
                        v-for="item in paymentMethods"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <div  @click="openMember"
                  class="flex-col justify-center items-center openMember-button text-wrapper margin-left-sm">
                <span class="text-df text-white">运营已收款<br/>立即开通</span>
            </div>
        </div>
        <services ref="services"></services>
        <bottomModal cla="rightXClose full auto-height bg-f5f5f5" ref="priceDetail">

            <div slot="part" class="padding-top-xl text-lg" v-if="price">
                <div class="text-600 text-center" style="font-size: 16px">优惠明细</div>
                <div class="margin-lr-sm bg-white radius margin-top-lg padding-lr-sm padding-top-lg padding-bottom-xl">
                    <div>
                        <div class="flex align-center justify-between">
                            <div>订单原价</div>
                            <div>¥{{price.originalAmount/100}}</div>
                        </div>
                        <template v-for="dl in price.discountList">
                            <div class="flex align-center justify-between margin-top-lg" v-if="dl.discountType=='折扣'">
                                <div>{{dl.discount==1?'免费版无折扣':('会员折扣'+discount(dl.discount)+'折')}}</div>
                                <div class="text-red">-¥{{dl.amount/100}}</div>
                            </div>
                            <div class="flex align-center justify-between margin-top-lg" v-else="">
                                <div>{{dl.discountType}}</div>
                                <div class="text-red">-¥{{dl.amount/100}}</div>
                            </div>
                        </template>
                    </div>
                    <div class="flex align-center justify-end" style="margin-top: 70px;">
                        <div class="text-df text-500">共减</div>
                        <div class="text-red margin-left-sm" style="font-size: 18px;">-¥{{(price.discountAmount)/100}}</div>
                    </div>
                </div>
                <div class="overbox padding-top-lg">
                    <div class="overbox-but" @click="priceDetailHide">确定</div>
                </div>
            </div>
        </bottomModal>
    </div>
</template>
<script>
  import App from '../util/comfun'
  import services from '../components/service-dialog.vue'
  import bottomModal from '../components/common/bottom-modal.vue'
  export default {
    props:{
      prices:{
        type:Array,
        value:[],
      },
      userinfo:{
        type:Object,
        value:null,
      },
      hasManager:{
        type:Boolean,
        value:false,
      },
      hasUsePayBut:{
        type:Boolean,
        value:false,
      },
      selected:{
        type:Number,
        value:-1,
      },
      VERSIONS:{
        type:Object,
        value:null,
      },
    },
    data () {
      return {
        hasDisplayDesc:false,
        serviceKey:'',
        amount:'',
        paymentMethods:[
          {value:'1',label:'1: 客户支付'},
          {value:'2',label:'2: 运营收款'},
          {value:'3',label:'3: 对公转账'},
          {value:'4',label:'4: 推广赠送'},
        ],
        paymentMethod:'',
        price:null,//金额对象
        count:1,
      }
    },
    components:{
      bottomModal,
      services,
    },
    methods:{
      handleCountChange(val){
        //console.log('handleCountChange',val,this.count)
        this.price=null
        App.demand('/activity/payment/queryVipAmount','POST',{
          serviceKey:this.serviceKey,
          "userId": this.userinfo.id,
          count:this.count,
        }).then(res=>{
          this.amount=res.data.currentAmount//抵扣后的实付金额
          this.price=res.data
        }).catch(()=>{
          this.amount=''
        })
      },
      priceDetailHide(){
        this.$refs.priceDetail.hide()
      },
      priceDetailShow(){
        this.$refs.priceDetail.show()
      },
      services(){
        this.$refs.services.show()
      },
        show(){
          this.hasDisplayDesc=true
        },
      hide(){
        this.hasDisplayDesc=false
        this.serviceKey=''
        this.amount=''
        this.paymentMethod=''
      },
      unixtoTime:App.unixtoTime,
      chooseServiceKey(val,item){
        this.serviceKey=val
        this.item=item
        this.amount=item.amount
        this.handleCountChange()
      },
      openMember(){
        if(!this.checkData()) return
        if(this.openMembering) return
        if(this.paymentMethod<1) return this.$message({ message: '请选择支付方式', type: "fail" });
        this.openMembering=true
        this.loading=this.$loading({text:'处理中...',target:'body'})
        App.demand('/admin/user/openMember','POST',{
          "paymentMethod": this.paymentMethod,
          "userId": this.userinfo.id,
          "openVip": 1,
          serviceKey:this.serviceKey,
          count:this.count,
        }).then(res=>{
          this.openMembering=false
          this.loading.close()
          if(res.code==200){
            this.payedEvent();
          }else{
            this.$message({ message: res.message, type: "fail" });
          }
        })
      },
      hasTest:App.hasTest,
      requestPayment(){
        if(!this.hasUsePayBut){//iphone
          return this.$router.push('/version-iphone')
        }
        if(!this.checkData()) return
        let userAgent=window.navigator.userAgent.toLocaleLowerCase().replace(/[ ]+/g,'')
        if(userAgent.indexOf('macos')>-1 && userAgent.indexOf('wxwork')>-1) {//mac+企微+小程序
          this.hasUseCode=true
        }
        App.demand('/activity/payment/pay','POST',{
          serviceKey:this.serviceKey,
          tradeType:(typeof WeixinJSBridge=='undefined' || this.hasUseCode)?2:1,//
          userId:this.userinfo.id,
          count:this.count,
        }).then(res=>{
          this.onBridgeReady(res.data)
          this.hasUseCode=false
        })

      },
      onBridgeReady(params){
        if(typeof WeixinJSBridge=='undefined' || this.hasUseCode){
          this.$emit('event',{payParams:params,item:this.item,amount:this.amount});
        }else{
          WeixinJSBridge.invoke('getBrandWCPayRequest', {
              "appId": "wx397090124c858e7c",     //公众号ID，由商户传入
              "timeStamp": params.timeStamp,     //时间戳，自1970年以来的秒数
              "nonceStr": params.nonceStr,      //随机串
              "package": "prepay_id="+params.prepayId,
              "signType": params.signType,//"RSA",     //微信签名方式：
              "paySign": params.signStr //微信签名
            },
            (res)=>{
              if(this.hasManager){
                this.$notify({
                  title: params.prepayId,
                  message: '<div style="word-break: break-all;width: 280px;">'+JSON.stringify(res)+'<br>'+window.navigator.userAgent+"</div>",
                  duration: 0,
                  dangerouslyUseHTMLString: true,
                });
                return;
              }
              if(res.err_msg){
                res.err_msg=res.err_msg.toLocaleLowerCase()
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  // 使用以上方式判断前端返回,微信团队郑重提示：
                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  return this.payedEvent();
                }
                if (res.err_msg.indexOf('cancel')>-1) return

                //发生 system:access_denied 错误且不是手机时显示二维码
                if((res.err_msg.indexOf('system:function_not_implement')>-1
                    || res.err_msg.indexOf('system:access_denied')>-1)
                  && window.navigator.userAgent.toLocaleLowerCase().indexOf('mobile')<0){//二维码
                  this.hasUseCode=true
                  const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  return setTimeout(()=>{this.requestPayment();loading.close();},2000)
                }
              }
              //其它全部使用小程序支付，小程序内不允许h5掉支付
              let url=App.http_build_query({
                params:JSON.stringify({
                  serviceKey:this.serviceKey,
                  userId:this.userinfo.id,
                  description:this.item.description,
                  selected:this.selected,
                  count:this.count,
                })
              },'/pages/wxpay/wxpay')
              return wx.miniProgram.redirectTo({
                url:url,
              })

            }
          );
        }
      },
      checkData(){
        //console.error(this.selected,this.userinfo.vipType,this.item)
        if(this.userinfo.vipType==1){
          this.$message({ message: '会员版请联系客服升级', type: "fail" });
          return false
        }
        if(this.amount<1){
          this.$message({ message: '当前选项不满足升级条件，请选择更高的套餐或版本', type: "fail" });
          return false
        }
        if(this.selected<this.userinfo.vipType){
          this.$message({ message: '当前为更高版本，暂时无法购买低版本，建议到期后购买', type: "fail" });
          return false
        }
        if(!this.serviceKey) {
          this.$message({ message: '请选择时长', type: "fail" });
          return false
        }
        return true
      },
      payedEvent(){
        this.$emit('event',{payed:true,item:this.item});
      },
    },
    created(){

    },
  }
</script>
<style scoped>
    @import "../../static/icon.css";
    .prices-dialog{
        .el-input-number{
            width: 140px;
            .el-input-number__decrease, .el-input-number__increase {
                position: absolute;
                z-index: 1;
                top: 1px;
                width: 40px;
                height: 38px!important;
                text-align: center;
                background: #F5F7FA;
                color: #606266;
                cursor: pointer;
                font-size: 13px;
                vertical-align: middle;
                line-height: 38px;
                padding-top: 12px;
            }
        }
    }
    .prices-dialog .cu-dialog{
        width: 375px;
        height: auto;
        background: #FFFFFF;
        border-radius: 8px 8px 0 0;
        overflow-y: auto;
    }
    .prices-dialog .close{
        position: absolute;
        right:15px;
        top:20px;
        background-image: url("https://assets.pfotoo.com/images/version/a9222631e6d96a459e3cd2d00551fe56.png");
        width: 20px;
        height: 20px;
        background-size: 100% 100%;
    }

    .prices-dialog .font_2 {
        font-size: 16px;
        font-family: 'PingFang SC';
        line-height: 22px;
        font-weight: 600;
        color: #5d5d5d;
    }
    .prices-dialog .font_3 {
        font-size: 16px;
        font-family: 'PingFang SC';
        line-height: 22px;
        font-weight: 500;
        color: #ddae58;
    }
    .prices-dialog .section_6 {
        padding: 21px 15px 0px 20px;
        background-color: #ffffff;
        border-radius: 8px 8px 0px 0px;
    }
    .prices-dialog .group_4 {
        height: 59px;
    }
    .prices-dialog .group_5 {
        margin-top: 15px;
        text-align: left;
        width: 243px;
    }
    .prices-dialog .font_4 {
        font-size: 16px;
        font-family: 'PingFang SC';
        line-height: 22px;
        font-weight: 500;
        color: #5d5d5d;
    }
    .prices-dialog .image_7 {
        margin-top: -59px;
        width: 20px;
        height: 20px;
    }
    .prices-dialog .grid {
        margin-right: 5px;
        margin-top: 30px;
        height: 245px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        row-gap: 26px;
        column-gap: 26px;
    }
    .prices-dialog .grid-item {
        padding: 20px 21px 29px;
        background-image: linear-gradient(0deg, #e09d59 0%, #e09d59 -5.84%, #f1dab9 133.57%, #f1dab9 100%);
        border-radius: 5px 30px 5px 5px;
    }
    .prices-dialog .text_5 {
        color: #ffffff;
    }
    .prices-dialog .font_6 {
        font-size: 14px;
        font-family: 'PingFang SC';
        line-height: 20px;
        color: #5d5d5d;
    }
    .prices-dialog .text_7 {
        color: #ffffff;
    }
    .prices-dialog .font_5 {
        font-size: 22px;
        font-family: 'PingFang SC';
        line-height: 30px;
        font-weight: 600;
        color: #5d5d5d;
    }
    .prices-dialog .text_6 {
        color: #ffffff;
        font-size: 21px;
        line-height: 29px;
    }
    .prices-dialog .grid-item_2 {
        padding: 30px 20px 0 20px;
        border-radius: 5px 30px 5px 5px;
        border: solid 1px #e0e0e0;
        width: 155px;
        height: 110px;
        box-sizing: border-box;
    }
    .prices-dialog .grid-item_3 {
        padding: 19px 0 28px;
        border-radius: 5px 30px 5px 5px;
        border: solid 1px #e0e0e0;
    }
    .prices-dialog .space-y-9 > *:not(:first-child) {
        margin-top: 9px;
    }
    .prices-dialog .text_8 {
        margin-left: 20px;
    }
    .prices-dialog .group_6 {
        padding: 0 20px;
    }
    .prices-dialog .space-x-4 > *:not(:first-child) {
        margin-left: 4px;
    }
    .prices-dialog .grid-item_4 {
        padding: 18px 20px 28px;
        border-radius: 5px 30px 5px 5px;
        border: solid 1px #e0e0e0;
    }
    .prices-dialog .space-y-10 > *:not(:first-child) {
        margin-top: 10px;
    }
    .openMember-view{
        position: fixed;
        bottom:543px;
        right:10px;
        z-index: 1111;
    }
    .openMember-button {
        width: 100px;
        height: 50px;
        padding: 9px 0;
        background-image: linear-gradient(0deg, #e09d59 0%, #e09d59 -5.84%, #f1dab9 133.57%, #f1dab9 100%);
        border-radius: 20px;
        text-align: center;
    }
    .serviceKey-selected{
        background-image: linear-gradient(0deg, #e09d59 0%, #e09d59 -5.84%, #f1dab9 133.57%, #f1dab9 100%);
        color: #ffffff;
    }
    .serviceKey-selected .font_2,.serviceKey-selected .font_5,.serviceKey-selected .font_6{
        color: #ffffff;
    }
    .prices-dialog .section_14 {
        padding-left: 21px;
        background-image: linear-gradient(0deg, #e09d59 0%, #e09d59 -5.84%, #f1dab9 133.57%, #f1dab9 100%);
        border-radius: 22.5px;
        width: 100%;
    }
    .prices-dialog .font_8 {
        font-size: 14px;
        font-family: 'PingFang SC';
        line-height: 20px;
        color: #faf6f6;
    }
    .prices-dialog .text_22 {
        margin-left: 11px;
        color: #faf6f6;
        font-size: 24px;
        font-family: 'PingFang SC';
        font-weight: 600;
        line-height: 33px;
    }
    .prices-dialog .text_24 {
        margin-left: 5px;
        margin-top: 9px;
    }
    .prices-dialog .button_2 {
        padding: 10px 0;
        background-image: linear-gradient(116.1deg, #424045 0%, #424045 -17.2%, #615d5d 50%, #615d5d 100%);
        border-radius: 22.5px;
        width: 130px;
        height: 45px;
    }
    .prices-dialog .text_23 {
        color: #faf6f6;
    }
    .font_5_x{
        height: 17px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        text-decoration: line-through;
        margin-left: 5px;
    }
    .yiyouhui{
        position: absolute;
        left: 0;
        top:-10px;
        min-width: 90px;
        height: 25px;
        background: #FFEFEF;
        border-radius: 5px 3px 10px 3px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        font-size: 12px;
        color: #FF6800;
        line-height: 25px;
        padding: 0 6px 0;
        text-align: left;
    }
    .gotoService{
        width: 100%;
        height: 35px;
        background: #F6F9FF;
        border-radius: 5px;

        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #BD8D49;
        margin-bottom: 10px;
        padding: 0 10px 0;
    }
    .gotoServiceIcon{
        width: 17px;
        height: 17px;
        background-image: url("https://assets.pfotoo.com/images/version/%E9%87%91%E8%9E%8D%E6%8A%95%E8%B5%84-icon@3x.png");
        background-size: 100% 100%;
        margin-right: 5px;
    }
    .pay-info-view{
        min-height: 100px;
        z-index:9;
        padding-bottom: 20px;
        position: relative;
        bottom: 0;
        left:0;
        padding: 8px 10px 24px;

        box-shadow: 0 0 2px 0 #e0e0e080;
        border-radius: 15px 15px 0 0;
        width: 100%;
    }
    .prices-dialog{
        .buy-box-sub{
            height: 15px;
            border-radius: 8px;
            opacity: 1;

            background: #FFDDB5;

            font-family: PingFang SC;
            font-size: 10px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0px;

            color: #BC7C3B;
            padding: 0 6px 0;

        }
        .overbox{
            width: 375px;
            height: 115px;
            background: #FFFFFF;
            box-shadow: 0 0 2px 0 #e0e0e080;
            border-radius: 15px 15px 0 0;
            margin-top: 70px;
        }
        .overbox-but{
            margin: 0 auto;
            width: 355px;
            height: 45px;
            background-image: linear-gradient(1deg, #E09D59 0%, #F1DAB9 100%);
            border-radius: 23px;

            font-family: PingFangSC-SNaNpxibold;
            font-weight: 600;
            font-size: 18px;
            color: #FAF6F6;
            text-align: center;
            line-height: 45px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/prices-dialog.vue